import measurement from '@js/store/inventory-fnb/modules/measurement';

export default {
    created() {
        if (!this.$store.hasModule('measurement')) {
            this.$store.registerModule('measurement', measurement);
        }
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory-fnb/measurement/store-mixin.js